import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Eyeglasses, Copy, ArrowsClockwise } from "@phosphor-icons/react";

export const GlassKeyCard = () => {
  const [key, setKey] = useState(null);

  useEffect(() => {
    api.get("/glass/key").then((r) => setKey(r.data.key)).catch(() => {});
  }, []);

  const create = async () => {
    try {
      const { data } = await api.post("/glass/key");
      setKey(data.key);
      toast.success("Ключ для очков создан");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const url = key ? `${window.location.origin}/glass?key=${key}` : null;

  const copy = () => {
    navigator.clipboard.writeText(url);
    toast.success("Ссылка скопирована — добавьте её в Meta AI app");
  };

  return (
    <div className="glass-card p-6" data-testid="glass-key-card">
      <div className="flex items-center gap-2 mb-2">
        <Eyeglasses size={20} weight="duotone" className="text-primary" />
        <h2 className="font-heading font-semibold">Очки Meta Display</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-3">
        Выводите «Сегодня» и «Здоровье» на очки Meta Ray-Ban Display. Создайте ключ и добавьте ссылку в Meta AI app: Настройки → App Connections → Web Apps.
      </p>
      {!key ? (
        <Button onClick={create} data-testid="glass-key-create">Создать ключ для очков</Button>
      ) : (
        <div className="flex items-center gap-2 flex-wrap">
          <code className="text-xs bg-black/30 rounded-lg px-3 py-2 truncate max-w-full" data-testid="glass-key-url">{url}</code>
          <Button size="sm" variant="outline" onClick={copy} data-testid="glass-key-copy"><Copy size={14} className="mr-1.5" />Копировать</Button>
          <Button size="sm" variant="ghost" onClick={create} data-testid="glass-key-rotate"><ArrowsClockwise size={14} className="mr-1.5" />Перевыпустить</Button>
        </div>
      )}
    </div>
  );
};
